import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'shared/contexts/AuthContext';
import { getDefaultRouteForRole } from 'shared/utils/roleRedirects';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoBack = () => {
    const defaultRoute = user?.role ? getDefaultRouteForRole(user.role) : '/login';
    navigate(defaultRoute);
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h3" gutterBottom>
          403
        </Typography>
        <Typography variant="h5" gutterBottom>
          Acceso No Autorizado
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" paragraph>
          No tiene permisos para acceder a esta página.
        </Typography>
        <Button
          variant="contained"
          onClick={handleGoBack}
          sx={{ mt: 3 }}
        >
          Volver al Inicio
        </Button>
      </Box>
    </Container>
  );
};